import moment from 'moment';

export default {
  name: 'es',
  el: {
    colorpicker: {
      confirm: 'Confirmar',
      clear: 'Limpiar',
    },
    datepicker: {
      now: 'Ahora',
      today: 'Hoy',
      cancel: 'Cancelar',
      clear: 'Limpiar',
      confirm: 'Confirmar',
      selectDate: 'Seleccione la fecha',
      selectTime: 'Seleccione la hora',
      startDate: 'Fecha inicial',
      startTime: 'Hora inicial',
      endDate: 'Fecha final',
      endTime: 'Hora final',
      prevYear: 'Año anterior',
      nextYear: 'Próximo año',
      prevMonth: 'Mes anterior',
      nextMonth: 'Próximo mes',
      year: '',
      month1: 'Enero',
      month2: 'Febrero',
      month3: 'Marzo',
      month4: 'Abril',
      month5: 'Mayo',
      month6: 'Junio',
      month7: 'Julio',
      month8: 'Agosto',
      month9: 'Septiembre',
      month10: 'Octubre',
      month11: 'Noviembre',
      month12: 'Diciembre',
      // week: 'semana',
      weeks: {
        sun: 'Dom',
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mié',
        thu: 'Jue',
        fri: 'Vie',
        sat: 'Sáb',
      },
      months: {
        jan: 'Ene',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Abr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Ago',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dic',
      },
    },
    table: {
      confirmFilter: 'Confirmar',
      resetFilter: 'Restablecer',
    },
    select: {
      noMatch: 'Sin resultados',
    },
    shortcuts: [
      {
        text: 'Ayer',
        value: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        key: 'yesterday',
      },
      {
        text: 'Últimos 7 días',
        value: [moment().subtract(7, 'days'), moment().subtract(1, 'days')],
        key: 'lastSevenDays',
      },
      {
        text: 'Últimos 30 días',
        value: [moment().subtract(30, 'days'), moment().subtract(1, 'days')],
        key: 'lastThirtyDays',
      },
      {
        text: 'Este mes',
        value: [moment().subtract(1, 'days').startOf('month'), moment().subtract(1, 'days').endOf('month')],
        key: 'thisMonth',
      },
      {
        text: 'Último mes',
        value: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        key: 'lastMonth',
      },
      {
        text: 'Últimos 6 meses',
        value: [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        key: 'lastSixMonths',
      },
      {
        text: 'Este año',
        value: [moment().startOf('year'), moment().subtract(1, 'days')],
        key: 'thisYear',
      },
      {
        text: 'Último año',
        value: [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
        key: 'lastYear',
      },
      {
        text: '12 meses + actual',
        value: [moment().subtract(12, 'months').startOf('month'), moment().subtract(1, 'days')],
        key: 'twelveMonthsPlusCurrent',
      },
    ],
  },
};
